module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (118).51310417.jpg";